import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceChip } from '../../components/ui/Choice';
import { TextAreaField } from '../../components/ui/Field';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { NONE_SITUATION, SITUATION_OPTIONS } from '../../data/quizOptions';
import { useCopy } from '../../contexts/LanguageContext';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
export function StepContext({
  profile,
  update,
  onNext
}: StepProps) {
  const copy = useCopy();
  function handleToggle(option: string) {
    if (option === NONE_SITUATION) {
      update({
        challenging_situations: profile.challenging_situations.includes(NONE_SITUATION) ? [] : [NONE_SITUATION]
      });
      return;
    }
    const withoutNone = profile.challenging_situations.filter(item => item !== NONE_SITUATION);
    update({
      challenging_situations: toggleValue(withoutNone, option)
    });
  }
  return <div className="flex flex-1 flex-col" data-id="element-120" data-mp="10xph6hpuzgu7">
      <Headline data-id="element-121" data-mp="10ul6d1hw1muk">{copy.steps.context.headline}</Headline>
      <Subtext data-id="element-122" data-mp="vwjm4d8q7hhi">{copy.steps.context.question}</Subtext>

      <div className="mt-6 space-y-3" data-id="element-123" data-mp="qyi5dyyrvu97">
        {SITUATION_OPTIONS.map(option => <ChoiceChip key={option} label={copy.options.situations[option]} selected={profile.challenging_situations.includes(option)} onSelect={() => handleToggle(option)} data-id="element-124" data-mp="r0kw6l7r1rez" />)}
      </div>

      <div className="mt-7" data-id="element-125" data-mp="1ep40yqrlbm2b">
        <TextAreaField id="parent-context" label={copy.steps.context.contextLabel} value={profile.parent_context} onChange={value => update({
        parent_context: value
      })} placeholder={copy.steps.context.contextPlaceholder} data-id="element-126" data-mp="1eoukpuwckt9t" />
      </div>

      <div className="mt-auto pt-10" data-id="element-127" data-mp="22f87b5w5xzx0">
        <PrimaryButton onClick={onNext} disabled={profile.challenging_situations.length === 0} data-id="element-128" data-mp="1xmyg7mjbatt5">
          {copy.quiz.continue}
        </PrimaryButton>
      </div>
    </div>;
}